import { TypeForm } from '@/containers/OwnBusinessForm/OwnBusinessForm';
import { serviceDirectoryApiClient } from '@/services/service-directory';

class Notification {
  createNotification = async (
    email: string,
    entityId: string,
    message: string,
    name: string,
    phone: string,
    type: TypeForm
  ) => {
    const formData = { email, entityId, message, name, phone, type };
    const response = await serviceDirectoryApiClient.post('/notifications', formData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  };
}

export const NotificationInstance = new Notification();
